<template>
    <div class="default-radio" :class="{error : errors.length, disabled: disabled}">
        <input class="default-radio__input" type="radio" :name="name" :id="id" :value="value" :required="required" :disabled="disabled" :checked="radioValue === value" ref="radioInput">
        <label class="default-radio__label" @click="handleClick">
            <div class="default-radio__img" v-if="icon || showIcon">
                <img v-if="icon" :src="icon" :alt="name" loading="lazy">
            </div>
            <span class="default-radio__name">{{ label }}</span>
            <span v-if="text" class="default-radio__text">{{ text }}</span>
        </label>
        <div class="tooltip" v-if="hintText">
            <span class="tooltip__btn" :class="{'opened':toolTipOpened}" @click="toolTipClick">?</span>
            <div class="tooltip__content">
                <p>{{ hintText }}</p>
            </div>
        </div>
        <div class="default-radio__error" v-if="errors.length">
            <span>{{ errors[0].$message }}</span>
        </div>
    </div>
</template>

<script>
export default {
    name: "InputRadio",
    data() {
      return {
        toolTipOpened: false
      };
    },
    props: {
        modelValue: {
            type: [Boolean, String, Number],
            default: false,
        },
        label: {
            type: String,
            required: true,
            default: ''
        },
        value: {
            type: [Boolean, String, Number],
            required: true,
            default: ''
        },
        icon: {
            type: String,
            default: ''
        },
        showIcon: {
            type: Boolean,
            default: false
        },
        required: {
            type: Boolean,
            default: false
        },
        name: {
            type: String,
            required: true,
            default: ''
        },
        hintText: {
            type: String,
            default: ''
        },
        text: {
            type: String,
            default: ''
        },
        id: {
            type: String,
            default: 'radios'
        },
        view: {
            type: String,
            default: 'tabs'
        },
        disabled: {
            type: Boolean,
            default: false
        },
        errors: {
            type: Array,
            default: () => []
        },
    },
    computed: {
        radioValue: {
            get() {
                return this.modelValue
            },
            set(value) {
                this.$emit('update:modelValue', value)
            }
        }
    },
    methods: {
        handleClick() {
            if (this.radioValue === this.value) {
                this.radioValue = '';
            } else {
                this.radioValue = this.value;
            }
        },
        toolTipClick() {
          this.toolTipOpened = this.toolTipOpened === false;
        },
    }
}
</script>

<style scoped>

</style>